import type { StaticImageData } from 'next/image';

import { LINKS } from '@/constants';

import genomeGraphic from '@images/sf2-graphic-genome.svg';
import exomeGraphic from '@images/sf2-graphic-exome.svg';
import variantGraphic from '@images/sf2-graphic-variant.svg';
import interpreterGraphic from '@images/sf2-graphic-interpreter.svg';
import gebraGraphic from '@images/sf2-graphic-gebra.svg';
// 일러스트 박스 배경(그레인 그라데이션 이미지, 제품별)
import genomeBg from '@images/sf2-bg-genome.webp';
import exomeBg from '@images/sf2-bg-exome.webp';
import variantBg from '@images/sf2-bg-variant.webp';
import interpreterBg from '@images/sf2-bg-interpreter.webp';
import gebraBg from '@images/sf2-bg-gebra.webp';

export type ProductKey =
  | 'interpreter'
  | 'exome'
  | 'genome'
  | 'variant'
  | 'gebra';

export interface Product {
  key: ProductKey;
  graphic: StaticImageData;
  // 그래픽 크기(반응형). 모바일 이미지 박스(245)가 데스크탑(314)보다 작아 base(모바일)→md(데스크탑)로 키운다.
  graphicCls: string;
  href: string;
  // 일러스트 박스 배경(그레인 그라데이션 이미지)
  illustBg: StaticImageData;
  // 질문 텍스트 그라데이션(bg-clip-text)
  questionGradient: string;
}

// 부채꼴 순서(좌→우): INTERPRETER · EXOME · GENOME · VARIANT · GEBRA
export const PRODUCTS: Product[] = [
  {
    key: 'interpreter',
    graphic: interpreterGraphic,
    graphicCls: 'h-[95px] w-auto md:h-[132px]',
    href: LINKS.INTERPRETER,
    illustBg: interpreterBg,
    questionGradient:
      'linear-gradient(75.48deg, rgba(158,190,149,0.689) 3.6%, rgba(0,185,96,0.83) 66.06%)',
  },
  {
    key: 'exome',
    graphic: exomeGraphic,
    graphicCls: 'h-[92px] w-auto md:h-[128px]',
    href: LINKS.WHOLE_EXOME,
    illustBg: exomeBg,
    questionGradient:
      'linear-gradient(75.79deg, rgba(122,157,195,0.83) 3.6%, rgba(44,118,229,0.83) 66.06%)',
  },
  {
    key: 'genome',
    graphic: genomeGraphic,
    graphicCls: 'h-[100px] w-auto md:h-[140px]',
    href: LINKS.WHOLE_GENOME,
    illustBg: genomeBg,
    questionGradient:
      'linear-gradient(74.62deg, rgba(221,149,149,0.83) 3.6%, rgba(255,27,27,0.83) 66.06%)',
  },
  {
    key: 'variant',
    graphic: variantGraphic,
    graphicCls: 'h-[108px] w-auto md:h-[150px]',
    href: LINKS.SANGER,
    illustBg: variantBg,
    questionGradient:
      'linear-gradient(75.48deg, rgba(227,165,123,0.83) 3.6%, rgba(249,74,28,0.83) 66.06%)',
  },
  {
    key: 'gebra',
    graphic: gebraGraphic,
    graphicCls: 'h-[94px] w-auto md:h-[130px]',
    href: LINKS.GEBRA,
    illustBg: gebraBg,
    questionGradient:
      'linear-gradient(73.89deg, rgba(223,146,241,0.689) 3.6%, rgba(171,56,238,0.83) 66.06%)',
  },
];

export const COUNT = PRODUCTS.length;
export const CENTER = Math.floor(COUNT / 2); // 2 = GENOME
